module.exports = __webpack_public_path__ + "img/Resilience_w.df167311.svg";